<template>
    <footer class="footer pt-3">
        <div class="container-fluid">
            <div class="row align-items-center justify-content-lg-between">
                <div class="col-lg-6 mb-lg-0 mb-4">
                    <div class="copyright text-center text-sm text-muted text-lg-start">
                        © {{Year}}
                        made with <i class="fa fa-heart" aria-hidden="true"></i> by
                        <a href="#" class="font-weight-bold" target="_blank">Lugar Creativo</a>
                    </div>
                </div>

                <div class="col-lg-6">
                    <ul class="nav nav-footer justify-content-center justify-content-lg-end">
                        <li class="cursor-pointer nav-item">
                            <a class="nav-link text-muted">Lugar Creativo</a>
                        </li>
                        <li class="nav-item">
                            <a class="cursor-pointer nav-link text-muted" @click="AbrirCalendario">Calendario</a>
                        </li>
                        <li class="nav-item">
                            <a class="cursor-pointer nav-link text-muted" @click="Abrir">Agendar</a>
                        </li>
                    </ul>
                </div>
            </div>
        </div>

        <CModal :pConfigModal="ConfigModal" :poBtnSave="oBtnSave">
			<template slot="Form">
				<FormAgenda :poBtnSave="oBtnSave"></FormAgenda>
			</template>
		</CModal>
        <CModal :pConfigModal="ConfigModalCalendario" :poBtnSave="oBtnSaveCalendario">
            <template slot="Form">
                <FormCalendario :pRegresarBool="false"></FormCalendario>
            </template>
        </CModal>
    </footer>
</template>

<script>
import moment from 'moment'
import FormCalendario from '@/views/modulos/crm/calendario/List.vue';
import FormAgenda from '@/views/modulos/crm/agenda/Form.vue';
const EmitEjecutaAgendaModal='seccionAgendaModal';
const EmitEjecutaCalendario='seccionCalendario';

export default {
    name: 'Foot',
    props: [""],
    components:{
        FormAgenda,FormCalendario
    },
    data() {
        return {
            Year: moment(new Date()).format('YYYY'),
            ConfigModalCalendario:{
                ModalTitle: "Calendario",
                ModalNameId: 'modal-2',
                EmitSeccion: EmitEjecutaCalendario,
                FullScreen:true,
                ShowFooter:false
            },
            oBtnSaveCalendario: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecutaCalendario,
            },
            ConfigModal:{
                ModalTitle: "Agenda",
                ModalNameId: 'modal-3',
                EmitSeccion: EmitEjecutaAgendaModal,
                ModalSize: 'lg'
            },
            oBtnSave: {
                Toast: 0,
                IsModal: true,
                DisableBtn: false,
                EmitSeccion: EmitEjecutaAgendaModal,
            },
        }
    },
    methods: {
            AbrirCalendario(){
                this.bus.$emit('NewModal_'+this.ConfigModalCalendario.EmitSeccion,0,{});
            },
            Abrir(){
                this.bus.$emit('NewModal_'+this.ConfigModal.EmitSeccion,0,{});
            }
        },
    created() {
    },
}

</script>